var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 538,
    viewBox: "0 0 426 538",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.283 412.632V412.272L426 378.56L423.773 374.74L367.283 407.18V238.977L294.617 197.957V122.063L360.629 159.484L365.028 151.817L214.74 66.65V0H210.285V66.65L59.998 151.817L64.397 159.484L210.285 76.808V150.71L57.7707 241.219V320.988L2.22729 288.715L0 292.535L57.7986 326.109V415.926L205.608 499.986L147.531 533.311L149.758 537.13L286.181 458.8L347.682 494.533L349.91 490.713L290.608 456.254L366.642 412.605H367.255L367.283 412.632ZM288.993 118.879H285.735V192.947L214.768 152.869V76.808L288.993 118.879ZM214.768 163.027L285.735 203.105V368.153L214.768 406.405V163.027ZM66.7078 246.284L210.341 161.034V409.643L142.13 370.007V218.079H133.249V364.859L66.7078 326.192V246.284ZM66.7078 331.285L133.249 369.952V448.642L66.7078 410.805V331.285ZM211.316 496.72L212.903 493.98L142.102 453.707V375.128L281.754 456.281L211.288 496.747L211.316 496.72ZM218.554 414.431L294.617 373.412V208.115L358.401 244.125V412.272L286.209 453.735L218.554 414.431Z",
    fill: "#545252",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo_background.7200d1aedcaef0e6fdf4dea33ded104d.svg";
export { ForwardRef as ReactComponent };